/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const protectionSaveResultDefaultsBookingCapCountMin = -9007199254740991
export const protectionSaveResultDefaultsBookingCapCountMax = 9007199254740991

export const protectionSaveResultDefaultsBookingCapDaysMin = -9007199254740991
export const protectionSaveResultDefaultsBookingCapDaysMax = 9007199254740991

export const protectionSaveResultDefaultsChallengePointsMin = -9007199254740991
export const protectionSaveResultDefaultsChallengePointsMax = 9007199254740991

export const protectionSaveResultDefaultsDailyAssessmentCeilingMin = -9007199254740991
export const protectionSaveResultDefaultsDailyAssessmentCeilingMax = 9007199254740991

export const protectionSaveResultDefaultsFillTimeMinMsMin = -9007199254740991
export const protectionSaveResultDefaultsFillTimeMinMsMax = 9007199254740991

export const protectionSaveResultDefaultsLimitsBlockSecMin = -9007199254740991
export const protectionSaveResultDefaultsLimitsBlockSecMax = 9007199254740991

export const protectionSaveResultDefaultsLimitsHardMin = -9007199254740991
export const protectionSaveResultDefaultsLimitsHardMax = 9007199254740991

export const protectionSaveResultDefaultsLimitsSoftMin = -9007199254740991
export const protectionSaveResultDefaultsLimitsSoftMax = 9007199254740991

export const protectionSaveResultDefaultsLimitsWindowSecMin = -9007199254740991
export const protectionSaveResultDefaultsLimitsWindowSecMax = 9007199254740991

export const protectionSaveResultDefaultsScorePoints01Min = -9007199254740991
export const protectionSaveResultDefaultsScorePoints01Max = 9007199254740991

export const protectionSaveResultDefaultsScorePoints03Min = -9007199254740991
export const protectionSaveResultDefaultsScorePoints03Max = 9007199254740991

export const protectionSaveResultEffectiveBookingCapCountMin = -9007199254740991
export const protectionSaveResultEffectiveBookingCapCountMax = 9007199254740991

export const protectionSaveResultEffectiveBookingCapDaysMin = -9007199254740991
export const protectionSaveResultEffectiveBookingCapDaysMax = 9007199254740991

export const protectionSaveResultEffectiveChallengePointsMin = -9007199254740991
export const protectionSaveResultEffectiveChallengePointsMax = 9007199254740991

export const protectionSaveResultEffectiveDailyAssessmentCeilingMin = -9007199254740991
export const protectionSaveResultEffectiveDailyAssessmentCeilingMax = 9007199254740991

export const protectionSaveResultEffectiveFillTimeMinMsMin = -9007199254740991
export const protectionSaveResultEffectiveFillTimeMinMsMax = 9007199254740991

export const protectionSaveResultEffectiveLimitsBlockSecMin = -9007199254740991
export const protectionSaveResultEffectiveLimitsBlockSecMax = 9007199254740991

export const protectionSaveResultEffectiveLimitsHardMin = -9007199254740991
export const protectionSaveResultEffectiveLimitsHardMax = 9007199254740991

export const protectionSaveResultEffectiveLimitsSoftMin = -9007199254740991
export const protectionSaveResultEffectiveLimitsSoftMax = 9007199254740991

export const protectionSaveResultEffectiveLimitsWindowSecMin = -9007199254740991
export const protectionSaveResultEffectiveLimitsWindowSecMax = 9007199254740991

export const protectionSaveResultEffectiveScorePoints01Min = -9007199254740991
export const protectionSaveResultEffectiveScorePoints01Max = 9007199254740991

export const protectionSaveResultEffectiveScorePoints03Min = -9007199254740991
export const protectionSaveResultEffectiveScorePoints03Max = 9007199254740991

export const protectionSaveResultOverridesBookingCapCountMin = -9007199254740991
export const protectionSaveResultOverridesBookingCapCountMax = 9007199254740991

export const protectionSaveResultOverridesBookingCapDaysMin = -9007199254740991
export const protectionSaveResultOverridesBookingCapDaysMax = 9007199254740991

export const protectionSaveResultOverridesChallengePointsMin = -9007199254740991
export const protectionSaveResultOverridesChallengePointsMax = 9007199254740991

export const protectionSaveResultOverridesDailyAssessmentCeilingMin = -9007199254740991
export const protectionSaveResultOverridesDailyAssessmentCeilingMax = 9007199254740991

export const protectionSaveResultOverridesFillTimeMinMsMin = -9007199254740991
export const protectionSaveResultOverridesFillTimeMinMsMax = 9007199254740991

export const protectionSaveResultOverridesLimitsBlockSecMin = -9007199254740991
export const protectionSaveResultOverridesLimitsBlockSecMax = 9007199254740991

export const protectionSaveResultOverridesLimitsHardMin = -9007199254740991
export const protectionSaveResultOverridesLimitsHardMax = 9007199254740991

export const protectionSaveResultOverridesLimitsSoftMin = -9007199254740991
export const protectionSaveResultOverridesLimitsSoftMax = 9007199254740991

export const protectionSaveResultOverridesLimitsWindowSecMin = -9007199254740991
export const protectionSaveResultOverridesLimitsWindowSecMax = 9007199254740991

export const protectionSaveResultOverridesScorePoints01Min = -9007199254740991
export const protectionSaveResultOverridesScorePoints01Max = 9007199254740991

export const protectionSaveResultOverridesScorePoints03Min = -9007199254740991
export const protectionSaveResultOverridesScorePoints03Max = 9007199254740991

export const protectionSaveResultUpdatedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const protectionSaveResultUpdatedByOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const ProtectionSaveResult = zod.object({
  defaults: zod.object({
    allowedEmbedOrigins: zod.array(zod.string()),
    bookingCap: zod.object({
      count: zod
        .int()
        .min(protectionSaveResultDefaultsBookingCapCountMin)
        .max(protectionSaveResultDefaultsBookingCapCountMax),
      days: zod
        .int()
        .min(protectionSaveResultDefaultsBookingCapDaysMin)
        .max(protectionSaveResultDefaultsBookingCapDaysMax),
    }),
    challengePoints: zod
      .int()
      .min(protectionSaveResultDefaultsChallengePointsMin)
      .max(protectionSaveResultDefaultsChallengePointsMax),
    counterChallengeMode: zod.enum(['monitor', 'enforce']),
    dailyAssessmentCeiling: zod
      .int()
      .min(protectionSaveResultDefaultsDailyAssessmentCeilingMin)
      .max(protectionSaveResultDefaultsDailyAssessmentCeilingMax),
    fillTimeMinMs: zod
      .int()
      .min(protectionSaveResultDefaultsFillTimeMinMsMin)
      .max(protectionSaveResultDefaultsFillTimeMinMsMax),
    limits: zod.record(
      zod.string(),
      zod.object({
        blockSec: zod
          .int()
          .min(protectionSaveResultDefaultsLimitsBlockSecMin)
          .max(protectionSaveResultDefaultsLimitsBlockSecMax)
          .optional(),
        hard: zod
          .int()
          .min(protectionSaveResultDefaultsLimitsHardMin)
          .max(protectionSaveResultDefaultsLimitsHardMax)
          .optional(),
        soft: zod
          .int()
          .min(protectionSaveResultDefaultsLimitsSoftMin)
          .max(protectionSaveResultDefaultsLimitsSoftMax)
          .optional(),
        windowSec: zod
          .int()
          .min(protectionSaveResultDefaultsLimitsWindowSecMin)
          .max(protectionSaveResultDefaultsLimitsWindowSecMax)
          .optional(),
      }),
    ),
    ruleOverrides: zod.record(zod.string(), zod.literal('monitor')),
    scoreChallengeMode: zod.enum(['monitor', 'enforce']),
    scorePoints: zod.object({
      '0.1': zod
        .int()
        .min(protectionSaveResultDefaultsScorePoints01Min)
        .max(protectionSaveResultDefaultsScorePoints01Max),
      '0.3': zod
        .int()
        .min(protectionSaveResultDefaultsScorePoints03Min)
        .max(protectionSaveResultDefaultsScorePoints03Max),
    }),
  }),
  effective: zod.object({
    allowedEmbedOrigins: zod.array(zod.string()),
    bookingCap: zod.object({
      count: zod
        .int()
        .min(protectionSaveResultEffectiveBookingCapCountMin)
        .max(protectionSaveResultEffectiveBookingCapCountMax),
      days: zod
        .int()
        .min(protectionSaveResultEffectiveBookingCapDaysMin)
        .max(protectionSaveResultEffectiveBookingCapDaysMax),
    }),
    challengePoints: zod
      .int()
      .min(protectionSaveResultEffectiveChallengePointsMin)
      .max(protectionSaveResultEffectiveChallengePointsMax),
    counterChallengeMode: zod.enum(['monitor', 'enforce']),
    dailyAssessmentCeiling: zod
      .int()
      .min(protectionSaveResultEffectiveDailyAssessmentCeilingMin)
      .max(protectionSaveResultEffectiveDailyAssessmentCeilingMax),
    fillTimeMinMs: zod
      .int()
      .min(protectionSaveResultEffectiveFillTimeMinMsMin)
      .max(protectionSaveResultEffectiveFillTimeMinMsMax),
    limits: zod.record(
      zod.string(),
      zod.object({
        blockSec: zod
          .int()
          .min(protectionSaveResultEffectiveLimitsBlockSecMin)
          .max(protectionSaveResultEffectiveLimitsBlockSecMax)
          .optional(),
        hard: zod
          .int()
          .min(protectionSaveResultEffectiveLimitsHardMin)
          .max(protectionSaveResultEffectiveLimitsHardMax)
          .optional(),
        soft: zod
          .int()
          .min(protectionSaveResultEffectiveLimitsSoftMin)
          .max(protectionSaveResultEffectiveLimitsSoftMax)
          .optional(),
        windowSec: zod
          .int()
          .min(protectionSaveResultEffectiveLimitsWindowSecMin)
          .max(protectionSaveResultEffectiveLimitsWindowSecMax)
          .optional(),
      }),
    ),
    ruleOverrides: zod.record(zod.string(), zod.literal('monitor')),
    scoreChallengeMode: zod.enum(['monitor', 'enforce']),
    scorePoints: zod.object({
      '0.1': zod
        .int()
        .min(protectionSaveResultEffectiveScorePoints01Min)
        .max(protectionSaveResultEffectiveScorePoints01Max),
      '0.3': zod
        .int()
        .min(protectionSaveResultEffectiveScorePoints03Min)
        .max(protectionSaveResultEffectiveScorePoints03Max),
    }),
  }),
  overrides: zod.object({
    allowedEmbedOrigins: zod.array(zod.string()).optional(),
    bookingCap: zod
      .object({
        count: zod
          .int()
          .min(protectionSaveResultOverridesBookingCapCountMin)
          .max(protectionSaveResultOverridesBookingCapCountMax),
        days: zod
          .int()
          .min(protectionSaveResultOverridesBookingCapDaysMin)
          .max(protectionSaveResultOverridesBookingCapDaysMax),
      })
      .optional(),
    challengePoints: zod
      .int()
      .min(protectionSaveResultOverridesChallengePointsMin)
      .max(protectionSaveResultOverridesChallengePointsMax)
      .optional(),
    counterChallengeMode: zod.enum(['monitor', 'enforce']).optional(),
    dailyAssessmentCeiling: zod
      .int()
      .min(protectionSaveResultOverridesDailyAssessmentCeilingMin)
      .max(protectionSaveResultOverridesDailyAssessmentCeilingMax)
      .optional(),
    fillTimeMinMs: zod
      .int()
      .min(protectionSaveResultOverridesFillTimeMinMsMin)
      .max(protectionSaveResultOverridesFillTimeMinMsMax)
      .optional(),
    limits: zod
      .record(
        zod.string(),
        zod.object({
          blockSec: zod
            .int()
            .min(protectionSaveResultOverridesLimitsBlockSecMin)
            .max(protectionSaveResultOverridesLimitsBlockSecMax)
            .optional(),
          hard: zod
            .int()
            .min(protectionSaveResultOverridesLimitsHardMin)
            .max(protectionSaveResultOverridesLimitsHardMax)
            .optional(),
          soft: zod
            .int()
            .min(protectionSaveResultOverridesLimitsSoftMin)
            .max(protectionSaveResultOverridesLimitsSoftMax)
            .optional(),
          windowSec: zod
            .int()
            .min(protectionSaveResultOverridesLimitsWindowSecMin)
            .max(protectionSaveResultOverridesLimitsWindowSecMax)
            .optional(),
        }),
      )
      .optional(),
    ruleOverrides: zod.record(zod.string(), zod.literal('monitor')).optional(),
    scoreChallengeMode: zod.enum(['monitor', 'enforce']).optional(),
    scorePoints: zod
      .object({
        '0.1': zod
          .int()
          .min(protectionSaveResultOverridesScorePoints01Min)
          .max(protectionSaveResultOverridesScorePoints01Max),
        '0.3': zod
          .int()
          .min(protectionSaveResultOverridesScorePoints03Min)
          .max(protectionSaveResultOverridesScorePoints03Max),
      })
      .optional(),
  }),
  rebuildRequired: zod.boolean(),
  updatedAt: zod.union([zod.iso.datetime({ offset: true }).regex(protectionSaveResultUpdatedAtOneRegExp), zod.null()]),
  updatedBy: zod.union([
    zod.object({
      name: zod.string(),
      userId: zod.uuid().regex(protectionSaveResultUpdatedByOneUserIdRegExp),
    }),
    zod.null(),
  ]),
})

export type ProtectionSaveResult = zod.input<typeof ProtectionSaveResult>
export type ProtectionSaveResultOutput = zod.output<typeof ProtectionSaveResult>
